import { render, staticRenderFns } from "./application-description-list.vue?vue&type=template&id=c818d8ca&scoped=true"
import script from "./application-description-list.vue?vue&type=script&lang=js"
export * from "./application-description-list.vue?vue&type=script&lang=js"
import style0 from "./application-description-list.vue?vue&type=style&index=0&id=c818d8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c818d8ca",
  null
  
)

export default component.exports